module.exports = __webpack_public_path__ + "static/card-winalot-feeding-greatness-2024-e5360308c7f936b152dfcca8bf0c75bf.png";